import serviceItemDialogSelector from './serviceitem-dialog-selector.vue'

serviceItemDialogSelector.install = function (Vue) {
	Vue.component(serviceItemDialogSelector.name, serviceItemDialogSelector);
}

export default serviceItemDialogSelector;